// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedCopy.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
* Advanced Copy component
*/
!function () {
  "use strict";
  require('share/utils/Izenda.StringUtilities');

  var React = require('react');
  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');

  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Panel = require('share/components/controls/Izenda.Panel');
  var AdvancedCopyToolbar = require('./Izenda.AdvancedCopyToolbar');
  var SourceDestinationContainer = require('./Izenda.SourceDestinationContainer');
  var Mapping = require('../Mapping/Izenda.Mapping');

  var AdvancedCopy = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function () {
      this.init();
    },

    init: m.action(function() {
      var store = this.props.store;
      var item = store.item;
      var selectedTenant = item.selectedTenant;
      var loader = this.props.loader;

      // load destination connections data source
      loader.startLoading();
      store.loadDestinationConnections()
        .then(selectedTenant.resetDirty)
        .then(item.updateMappingData.bind(item, selectedTenant))
        .finally(loader.endLoading.bind(loader));
    }),

    renderHeader: function () {
      var store = this.props.store;
      var selectedTenant = store.item.selectedTenant;
      var localization = this.props.localization;

      return (
        <Panel>
           <GridLayout>
              <GridLayout.Row>
                <GridLayout.Col cols={12}>
                  <span className='text-bold u_inlineBlock'>{localization.getText("COPY_MANAGEMENT_LABEL_DATA_ADVANCED_OPTIONS")}</span>
                  <span className='u_inlineBlock text-bold'>&nbsp; {selectedTenant.tenantName}</span>
                </GridLayout.Col>
              </GridLayout.Row>
           </GridLayout>
        </Panel>
      )
    },

    render: function () {
      var props = this.props;
      var store = props.store;
      var item = store.item;
      var selectedTenant = item.selectedTenant;

      return (
        <section className="izenda-Wrapper">

          <AdvancedCopyToolbar store={store} />

          <div className="izenda-Wrapper-content">

            <ScrollBox>

              <div className="u_paddingLeftRight">

                {this.renderHeader()}

                <Mapping
                  store={store}
                  tenantMode={true}
                  item={item}
                  dataSource={selectedTenant.dataMapping}
                  addMapping={selectedTenant.addMapping.bind(selectedTenant)}
                  width={props.width}/>

                <SourceDestinationContainer
                  store={store}/>

              </div>

            </ScrollBox>
          </div>

        </section>
      );
    }
  });

  module.exports = connect()(AdvancedCopy);
}();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/AdvancedCopy/Izenda.AdvancedCopy.jsx